/* tslint:disable */
/* eslint-disable */
/**
 * PokerWise Transaction Management
 * API for managing PokerWise transactions.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export * from './services/default-api';
